import { DailyMealRecord } from "../api/dailyAvailability";
import { getDailyMealStatus } from "./dailyMealStatus";

export interface MealCategory {
  _id: string;
  name: string;
  displayOrder?: number;
}

export function groupDailyMeals(records: DailyMealRecord[], categories: MealCategory[] = []) {
  const groups = new Map<string, { id: string; name: string; order: number; records: DailyMealRecord[] }>();
  for (const record of records) {
    const category = record.mealId.categoryId;
    const id = typeof category === "string" ? category : category?._id || "uncategorized";
    const configured = categories.find(entry => entry._id === id);
    if (!groups.has(id)) groups.set(id, {
      id,
      name: configured?.name || (typeof category === "object" ? category?.name : undefined) || "Uncategorized",
      order: configured?.displayOrder ?? Number.MAX_SAFE_INTEGER,
      records: [],
    });
    groups.get(id)!.records.push(record);
  }
  return Array.from(groups.values()).sort((a, b) =>
    Number(a.id === "uncategorized") - Number(b.id === "uncategorized") ||
    a.order - b.order || a.name.localeCompare(b.name));
}

export function categoryStockSummary(records: DailyMealRecord[]) {
  const available = records.filter(record => getDailyMealStatus(record) === "LIVE");
  const pools = new Map<string, number>();
  let portions = 0;
  for (const record of available) {
    if (record.stockMode === "UNLIMITED") continue;
    const remaining = Math.max(0, record.remainingQuantity || 0);
    if (record.sharedStockGroupId) {
      const id = String(record.sharedStockGroupId);
      pools.set(id, Math.min(pools.get(id) ?? Infinity, remaining));
    } else portions += remaining;
  }
  return {
    available: available.length,
    portions,
    sharedPortions: Array.from(pools.values()).reduce((sum, quantity) => sum + quantity, 0),
    sharedPools: pools.size,
    unlimited: available.filter(record => record.stockMode === "UNLIMITED").length,
  };
}
